import {
  WbTableFilters,
  ProviderFilters,
  SearchFilter,
  EnumFilter,
} from '@agilelab/plugin-wb-platform';
import usePolicyContext from './PolicyProvider';
import { Severity, Status } from '@agilelab/plugin-wb-governance-common';

export interface PolicyFilters extends ProviderFilters {
  status?: string[];
  severity?: any[];
}

enum AvailablePolicyFilters {
  search = 'search',
  status = 'status',
  severity = 'severity',
}

interface FilterProps {
  value: string[];
  changeFilters: <K extends keyof PolicyFilters>(
    key: K,
    value: PolicyFilters[K],
  ) => void;
  options: string[];
}

const fromEnum = (e: Record<string, string>) => Object.values(e);

const statusItems = fromEnum(Status).filter(
  s => s !== Status.Deleted && s !== Status.DisabledGrace,
) as Status[];

const severityItems = fromEnum(Severity) as Severity[];

const StatusFilters: React.FC<FilterProps> = ({
  value,
  changeFilters,
  options,
}) => {
  return (
    <EnumFilter<string>
      field="Status"
      value={value}
      onChange={status => {
        changeFilters('status', status);
      }}
      renderOption={o => o}
      renderValue={v => v}
      onSearch={searchValue =>
        options.filter(option => new RegExp(searchValue, 'ig').test(option))
      }
      options={options}
    />
  );
};

const SeverityFilter: React.FC<FilterProps> = ({
  value,
  changeFilters,
  options,
}) => {
  return (
    <EnumFilter<string>
      field="Severity"
      value={value}
      onChange={severity => {
        changeFilters('severity', severity);
      }}
      renderOption={o => o}
      renderValue={v => v}
      onSearch={searchValue =>
        options.filter(option => new RegExp(searchValue, 'ig').test(option))
      }
      options={options}
    />
  );
};

export const PolicyFiltersSection = () => {
  const { filters, changeFilters, resetFilters, templateKind } =
    usePolicyContext();

  const filterElement = (key: string) => {
    if (key === AvailablePolicyFilters.search)
      return (
        <SearchFilter
          key={key}
          value={filters.search ?? ''}
          changeFilters={changeFilters}
        />
      );

    if (key === AvailablePolicyFilters.status)
      return (
        <StatusFilters
          key={key}
          value={filters.status ?? []}
          changeFilters={changeFilters}
          options={statusItems}
        />
      );

    if (key === AvailablePolicyFilters.severity)
      return (
        <SeverityFilter
          key={key}
          value={filters.severity ?? []}
          changeFilters={changeFilters}
          options={severityItems}
        />
      );

    return <></>;
  };

  return (
    <WbTableFilters onClear={resetFilters}>
      {templateKind?.userFilters?.map((filter: string) =>
        filterElement(filter),
      )}
    </WbTableFilters>
  );
};
